// FilterButton.js
import React from "react";

function FilterButton({ category, isSelected, onClick }) {
  return (
    <button
      className={`filterOptions ${isSelected ? 'active' : ''}`}
      onClick={() => onClick(category)}
    >
      {category}
    </button>
  );
}

export default FilterButton;
